var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row justify-content-center" }, [
    _vm.profile
      ? _c("div", { staticClass: "account-container" }, [
          _c("h2", { staticClass: "title-text mx-auto" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("button.settings")) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mx-0 mt-3 flex-md-row flex-column" }, [
            _c(
              "div",
              { staticClass: "col px-4 d-flex flex-column align-items-center" },
              [
                _c(
                  "ValidationObserver",
                  { ref: "accountObserver" },
                  [
                    _c("v-input", {
                      staticClass: "input-w-default mb-0 mt-2",
                      attrs: {
                        ind: "0",
                        type: "text",
                        placeholder: _vm.$t("placeholder.name"),
                        icon: _vm.$getInputIcon(_vm.name, "name"),
                        rules: "required",
                      },
                      on: { input: _vm.accountEdited },
                      model: {
                        value: _vm.name,
                        callback: function ($$v) {
                          _vm.name = $$v
                        },
                        expression: "name",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-input", {
                      staticClass: "input-w-default mb-0 mt-2",
                      attrs: {
                        ind: "1",
                        type: "text",
                        placeholder: _vm.$t("placeholder.surname"),
                        icon: _vm.$getInputIcon(_vm.surname, "name"),
                        rules: "required",
                      },
                      on: { input: _vm.accountEdited },
                      model: {
                        value: _vm.surname,
                        callback: function ($$v) {
                          _vm.surname = $$v
                        },
                        expression: "surname",
                      },
                    }),
                    _vm._v(" "),
                    _vm.teacher
                      ? _c("v-input", {
                          staticClass: "input-w-default mb-0 mt-2",
                          attrs: {
                            ind: "2",
                            type: "tel",
                            placeholder: _vm.$t("placeholder.phone"),
                            icon: _vm.$getInputIcon(_vm.phone, "phone"),
                            rules: "required|phone",
                          },
                          on: { input: _vm.accountEdited },
                          model: {
                            value: _vm.phone,
                            callback: function ($$v) {
                              _vm.phone = $$v
                            },
                            expression: "phone",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.teacher
                      ? _c("v-input", {
                          staticClass: "input-w-default mb-0 mt-2",
                          attrs: {
                            ind: "3",
                            type: "text",
                            placeholder: _vm.$t("placeholder.work"),
                            icon: _vm.$getInputIcon(_vm.work, "work"),
                            rules: "required",
                          },
                          on: { input: _vm.accountEdited },
                          model: {
                            value: _vm.work,
                            callback: function ($$v) {
                              _vm.work = $$v
                            },
                            expression: "work",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.teacher
                      ? _c("v-input", {
                          staticClass: "input-w-default mb-0 mt-2",
                          attrs: {
                            ind: "4",
                            type: "text",
                            placeholder: _vm.$t("placeholder.position"),
                            icon: _vm.$getInputIcon(_vm.position, "position"),
                            rules: "required",
                          },
                          on: { input: _vm.accountEdited },
                          model: {
                            value: _vm.position,
                            callback: function ($$v) {
                              _vm.position = $$v
                            },
                            expression: "position",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "ValidationObserver",
                  { ref: "mailObserver" },
                  [
                    _c("v-input", {
                      staticClass: "input-w-default mb-0 mt-2",
                      attrs: {
                        ind: "5",
                        type: "text",
                        placeholder: _vm.$t("placeholder.email"),
                        icon: _vm.$getInputIcon(_vm.mail, "email"),
                        debounce: 500,
                        rules: "required|email|emailNotExists",
                        disabled: _vm.profile.mailExists,
                      },
                      model: {
                        value: _vm.mail,
                        callback: function ($$v) {
                          _vm.mail = $$v
                        },
                        expression: "mail",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "change-button",
                        on: { click: _vm.changeMail },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.mailButtonText) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "change-button",
                        attrs: {
                          to: "/change-password",
                          disabled: !_vm.profile.mailExists,
                        },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.passwordButtonText) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col px-4" },
              [
                _vm.features.vkAuth
                  ? _c(
                      "b-button",
                      {
                        staticClass: "vk-button position-relative",
                        staticStyle: { "margin-top": "51px" },
                        on: {
                          click: function ($event) {
                            _vm.profile.mailExists
                              ? _vm.updateVK()
                              : _vm.validateMail()
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "social-icon",
                          attrs: {
                            src: require("../assets/images/socialIcons/vk.svg"),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center ml-3" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.textVK) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("confirm-modal", {
                  ref: "vkLinkedModalConfirm",
                  attrs: {
                    message: _vm.messageVkLinked,
                    description: _vm.$t("message.startBot"),
                    "use-no-button": "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "yes-button",
                        fn: function () {
                          return [
                            _c(
                              "b-button",
                              {
                                staticClass:
                                  "button button-social-linked px-3 position-relative",
                                on: { click: _vm.toVkNotificationBot },
                              },
                              [
                                _c("img", {
                                  staticClass: "position-absolute",
                                  staticStyle: {
                                    left: "1rem",
                                    "margin-top": "0.125rem",
                                  },
                                  attrs: {
                                    src: require("../assets/images/socialIcons/vk.svg"),
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "social-text" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t("button.go")) +
                                      "\n                            "
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3401684268
                  ),
                }),
                _vm._v(" "),
                _c("notify-settings"),
                _vm._v(" "),
                _vm.features.vkAuth
                  ? _c("div", { staticClass: "justify-content-center" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "text-white font-weight-light mb-2 text-notification",
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("message.subscribeNotifications")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row justify-content-center" },
                        [
                          _vm.features.vkAuth
                            ? [
                                _c(
                                  "div",
                                  { attrs: { id: "disabled-vk-button" } },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass:
                                          "social-button position-relative",
                                        attrs: {
                                          href: _vm.vkBot,
                                          disabled: !_vm.vkLinked,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.updatePreferredMailingMethod(
                                              _vm.$defines.MAILING_METHODS.VK
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: require("../assets/images/socialIcons/vk.svg"),
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.vkLinked
                                  ? _c(
                                      "b-popover",
                                      {
                                        attrs: {
                                          target: "disabled-vk-button",
                                          triggers: "hover focus",
                                          placement: "bottom",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$t(
                                                "popover.subscribeNotifications",
                                                "",
                                                { social: _vm.$t("common.vk") }
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "text-white font-weight-light mb-2 text-type-select",
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.messagePriority")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-dropdown",
                  {
                    staticClass: "position-relative notify-type-combo",
                    attrs: {
                      offset: "25",
                      "toggle-class": "mailing-dropdown-button",
                      "menu-class": "mailing-dropdown-menu",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button-content",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-items-center" },
                                [
                                  _c("img", {
                                    staticClass: "ml-3",
                                    class:
                                      _vm.preferredMailingMethod ===
                                      _vm.$defines.MAILING_METHODS.NONE
                                        ? "icon-no-notify"
                                        : "icon",
                                    attrs: { src: _vm.notifyMethodSelectIcon },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "ml-3" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.notificationTypeLabel) +
                                        "\n                            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "ml-auto",
                                    attrs: {
                                      src: require("images/headerIcons/arrow-white.svg"),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      4216896384
                    ),
                  },
                  [
                    _vm._v(" "),
                    _vm.emailExists
                      ? _c(
                          "b-dropdown-item",
                          {
                            staticClass:
                              "mailing-dropdown-item-last header-text item-substrate",
                            on: {
                              click: function ($event) {
                                return _vm.updatePreferredMailingMethod(
                                  _vm.$defines.MAILING_METHODS.EMAIL
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "icon ml-1",
                              attrs: {
                                src: require("../assets/images/formIcons/email-fill.svg"),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "ml-3" }, [
                              _vm._v(
                                "\n                            E-mail\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.preferredMailingMethod ===
                            _vm.$defines.MAILING_METHODS.EMAIL
                              ? _c("img", {
                                  staticClass: "ml-auto mr-n3",
                                  attrs: {
                                    src: require("images/headerIcons/tick.svg"),
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.vkLinked && _vm.features.vkAuth
                      ? _c(
                          "b-dropdown-item",
                          {
                            staticClass:
                              "mailing-dropdown-item header-text item-substrate",
                            on: {
                              click: function ($event) {
                                return _vm.updatePreferredMailingMethod(
                                  _vm.$defines.MAILING_METHODS.VK
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "icon ml-1",
                              attrs: {
                                src: require("../assets/images/socialIcons/vk.svg"),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "mx-3" }, [
                              _vm._v(
                                "\n                            VK\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.preferredMailingMethod ===
                            _vm.$defines.MAILING_METHODS.VK
                              ? _c("img", {
                                  staticClass: "ml-auto mr-n3",
                                  attrs: {
                                    src: require("images/headerIcons/tick.svg"),
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      {
                        staticClass:
                          "mailing-dropdown-item-first header-text item-substrate",
                        on: {
                          click: function ($event) {
                            return _vm.updatePreferredMailingMethod(
                              _vm.$defines.MAILING_METHODS.NONE
                            )
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "ml-1",
                          attrs: {
                            src: require("../assets/images/headerIcons/cross.svg"),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "no-notify-text" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("label.noNotify")) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.preferredMailingMethod ===
                        _vm.$defines.MAILING_METHODS.NONE
                          ? _c("img", {
                              staticClass: "ml-auto mr-n3",
                              attrs: {
                                src: require("images/headerIcons/tick.svg"),
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.mireraTeacher
            ? _c("div", { staticClass: "flex-wrap" }, [
                _c("small", { staticClass: "hint-text" }, [
                  _vm._v(_vm._s(_vm.$t("message.refuseMireraTeacher"))),
                  _c(
                    "a",
                    {
                      staticClass: "text-link",
                      attrs: { href: "#0" },
                      on: { click: _vm.confirmAnnulAccountType },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("button.clickHere")) +
                          "\n                "
                      ),
                      _c("confirm-modal", {
                        ref: "modalConfirm",
                        attrs: {
                          message: _vm.$t("message.confirmRefuseMireraTeacher"),
                          "use-no-button": "",
                        },
                        on: { confirmed: _vm.annulAccountType },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }